// src/services/settings/backup.service.js
import axios from "axios";
import { buildHeaders } from "../_headers.util";

const API_URL = `${process.env.VUE_APP_API_URL}settings/backups/`;

export default {
  /**
   * Returns { system: [...], database: [...] }
   */
  getAll() {
    return axios.get(API_URL, { headers: buildHeaders() });
  },

  generate(type) {
    return axios.post(
      `${API_URL}generate`,
      { type },
      { headers: buildHeaders() }
    );
  },

  download(id) {
    // For programmatic download you may want { responseType: 'blob' }
    return axios.get(`${API_URL}${id}/download`, {
      headers: buildHeaders(),
      responseType: "blob",
    });
  },

  delete(id) {
    return axios.delete(`${API_URL}${id}`, { headers: buildHeaders() });
  },

  bulkDelete(ids) {
    return axios.post(
      `${API_URL}bulk-delete`,
      { ids },
      { headers: buildHeaders() }
    );
  },
};
